import { useEffect, useState } from 'react';
import { View } from 'foundations-components/components/View';
import { useFeatureMonetizationTracker } from '../../FeatureMonetizationTrackerProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableCellWrapperWithHoverTracking = ({
  children,
  trackingProperties
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [timeoutId, setTimeoutId] = useState();
  const tracker = useFeatureMonetizationTracker();
  useEffect(() => {
    if (isHovered) {
      const newTimeoutId = setTimeout(() => {
        if (isHovered) {
          tracker.track(Object.assign({}, trackingProperties, {
            action: 'on-feature-cell-hover',
            object: 'feature-table'
          }));
        }
      }, 750);
      setTimeoutId(newTimeoutId);
    }
  }, [isHovered, trackingProperties, tracker]);
  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);
  return /*#__PURE__*/_jsx(View, {
    as: "td",
    onMouseEnter: () => {
      setIsHovered(true);
    },
    onMouseLeave: () => {
      setIsHovered(false);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    },
    children: children
  });
};